import React, { useEffect, useState } from "react";
import "./Single_order_page.css";
import { useParams } from "react-router-dom";
import { Calculate } from "@mui/icons-material";

function SingleOrderDetails() {
  const orderId = useParams().orderId;
  const [orderDetails, setOrderDetails] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [cart, setCart] = useState([]);

  const parsingFunction = (data) => {
    const cleanedBody = data.replace(/NaN/g, "null");
    const parsedData = JSON.parse(cleanedBody);
    //console.log("parsedData from orderdetails ", parsedData);
    return parsedData;
  }
  const fetchorders = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/retrive-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });
      const data = await response.json();
      const parsedData = parsingFunction(data.body);
      return parsedData;

    } catch (error) {
      console.error("Error fetching order details:", error);
    }
  }

  useEffect(() => {
    const fetchOrderDetails = async () => {
      const data = await fetchorders();
      const orderdata = data.filter((order) => order.order_id === orderId);
      //console.log("orderdata", orderdata[0]);
      setOrderDetails(orderdata[0]);
      setBillingAddress(parsingFunction(orderdata[0].billing_address));
      setShippingAddress(parsingFunction(orderdata[0].shipping_address));
      setCart(parsingFunction(orderdata[0].cart));

      setOrderDetails(orderdata);
    };

    fetchOrderDetails();
  }, []);

  if (!orderDetails) return <p>Loading...</p>;

  const calculateTotal = () => {
    let total = 0;
    cart.forEach((item) => {
      total += item.price * item.quantity;
    });
    return total;
  };

  return (
    <div>
      <p>Order <strong>{orderDetails[0]?.order_id}</strong> was placed on <strong>{orderDetails[0]?.created_at}</strong> and is currently <strong>{orderDetails[0]?.order_status}</strong>.</p>
      <div className="order-details-container">
        <table className="order-details-table">
          <tbody>

            <tr>
              <td className="order-label">Product</td>
              <td className="order-value">
                {
                  cart.map((item, index) => (
                    <>
                      <a
                        href={`/product/${item?.model}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="product-link"
                      >
                        {item?.name}
                      </a>{ " "}
                 <p>{`X${item?.quantity}`}</p>
                 </>
                  ))
                }
              </td>
            </tr>
            <tr>
              <td className="order-label">Subtotal</td>
              <td className="order-value">{calculateTotal()}</td>
            </tr>
            <tr>
              <td className="order-label">Shipping</td>
              <td className="order-value">{(calculateTotal()>5000)?"Free Shipping":orderDetails[0]?.shipping_cost}</td>
            </tr>
            <tr>
              <td className="order-label">Payment method</td>
              <td className="order-value">{orderDetails?.paymentMethod}</td>
            </tr>
            <tr>
              <td className="order-label">Total</td>
              <td className="order-value">{(calculateTotal()>5000)?calculateTotal():( calculateTotal() + orderDetails[0]?.shipping_cost)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <button className="view-order-message-button">View order Message</button>

      <div className="address-details">
        <div>
          <h4>Billing Address</h4>
          <p>{billingAddress?.first_name} {billingAddress?.last_name} </p>
          <p>{billingAddress?.street_address}</p>
          <p>{billingAddress?.apartment}</p>
          <p>{billingAddress?.city} {billingAddress?.pincode}</p>
          <p>{billingAddress?.state}</p>
        </div>
        <div>
          <h4>Shipping Address</h4>
          <p>{shippingAddress?.first_name} {billingAddress?.last_name} </p>
          <p>{shippingAddress?.street_address}</p>
          <p>{shippingAddress?.apartment}</p>
          <p>{shippingAddress?.city} {billingAddress?.pincode}</p>
          <p>{shippingAddress?.state}</p>
        </div>
      </div>

      <p><strong>Phone Number:</strong> {orderDetails[0]?.phone_no}</p>
      <p><strong>Email:</strong> {billingAddress?.email}</p>

      <h4 className="other-extra">Other Extra</h4>
      <div className="landmark">
        <p><strong>Landmark:</strong></p>
        <p>{billingAddress?.landmark}</p>
      </div>
    </div>

  );
}

export default SingleOrderDetails;
